import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/Services/utils.service';

@Component({
  selector: 'app-student-listv2',
  templateUrl: './student-listv2.component.html',
  styleUrls: ['./student-listv2.component.scss']
})
export class StudentListv2Component implements OnInit {
  browserDomain: string = window.location.hostname;

  constructor(private router: Router, private util: UtilsService) { }

  ngOnInit() {
    if(!this.browserDomain.includes('extramarks')){
      let hostName = window.location.hostname;
      let domainParts = hostName.split('.');
      let extractedDomain = domainParts.length > 2 ? domainParts.slice(1).join('.') : hostName;
      if(!(extractedDomain === 'oderp.in' || extractedDomain === 'odpay.in'))
      {
          window.open(this.util.loginUrl, "_blank");
          return;
      }
      let redirectUrl = environment.reactConfig.studentList.host + extractedDomain + environment.reactConfig.studentList.path;
      
      const entity = localStorage.getItem('entityId') || '';
      const session = localStorage.getItem('session') || '';
      redirectUrl += `?entity=${entity}&session=${session}`;
      
      const lastTime = sessionStorage.getItem('studentListRedirectTime');
      const now = Date.now();
      const isCooldown = lastTime && (now - parseInt(lastTime)) < 2000;
      
      if(!sessionStorage.getItem('studentListRedirect') || !isCooldown) {
        sessionStorage.setItem('studentListRedirect', 'true');
        sessionStorage.setItem('studentListRedirectTime', now.toString());
        window.open(redirectUrl, "_blank");
        setTimeout(() => {
          sessionStorage.removeItem('studentListRedirect');
          sessionStorage.removeItem('studentListRedirectTime');
        }, 2000);
      }
      
      setTimeout(() => {
        this.router.navigate(['/entity/dashboard']);
      }, 50);
    }
  }
}
